import { auth, firestore } from '@/plugins/firebase'

const FIRST_LOAD_ACTIONS = [
  'waitForLogin',
  // 'user/bind',
  'user/bindEngagement'
]

// convenience variable to pass args between async.each
let lastReturn = null

export default {
  waitForLogin ({ commit }) {
    return new Promise((resolve, reject) => {
      const user = auth.currentUser

      commit('user/setCurrentUser', user)

      if (user) {
        // update user detils on firestore
        firestore
          .collection('users')
          .doc(user.uid)
          .update({
            displayName: user.displayName,
            photoURL: user.photoURL
          })

        lastReturn = user.uid
        // if (router.currentRoute.name === 'login') {
        //   router.push({
        //     path: router.currentRoute.query.redirect || '/'
        //   })
        // }
        resolve()
      } else {
        // Not logged in, stop the init process
        resolve({ stop: true })
      }
    })
  },
  doFirstLoad ({ commit, dispatch }, { reload } = { reload: false }) {
    commit('setAppLoading', true)

    return new Promise(async (resolve, reject) => {
      for (let i in FIRST_LOAD_ACTIONS) {
        const action = FIRST_LOAD_ACTIONS[i]

        try {
          const resolved = await dispatch(action, lastReturn)

          // If dispatch() promise resolve with a truthy arg, then stop
          // ex.: this is used if not logged-in to stop the init without reject()
          if (resolved && resolved.stop) { break }
        } catch (err) {
          console.warn('Error in First Load', action, err)
          reject(err)
          break
        }
      }

      commit('setAppLoading', false)

      resolve()
    })
  }
}
